import { Link2, Shield, Check, Lock } from 'lucide-react'

import { AutoUnsubscribeSettings } from './AutoUnsubscribeSettings'

const OPT_OUT_SAFETY_ITEMS = [
  {
    title: 'Enable opt-out handling',
    description: 'Process unsubscribe requests automatically',
  },
  {
    title: 'Auto-remove unsubscribes',
    description: 'Immediately stop sending to contacts who unsubscribe',
  },
  {
    title: 'Stop sequence on reply',
    description: 'Stop sending follow-ups when a contact replies',
  },
  {
    title: 'Bounce detection',
    description:
      'Hard bounces stop the sequence immediately. High bounce rates temporarily pause sending to protect your domain.',
  },
] as const

export function SequencingSettings() {
  return (
    <div className="flex-1 overflow-auto">
      <div className="max-w-2xl mx-auto px-8 py-8">
        <div className="mb-8">
          <h2 className="text-xl font-semibold text-fg">Sequencing</h2>
          <p className="text-fg-secondary text-sm mt-1">
            These settings apply to all campaigns. Changes here affect every
            active and future campaign.
          </p>
        </div>

        <div className="space-y-6">
          <div className="bg-surface rounded-xl border border-line p-5">
            <div className="flex items-center gap-3 mb-3">
              <div className="size-9 rounded-lg bg-brand/10 flex items-center justify-center">
                <Link2 className="size-4 text-brand" />
              </div>
              <div>
                <h3 className="text-sm font-semibold text-fg">
                  Reply opt-out detection
                </h3>
                <p className="text-xs text-fg-secondary">
                  How we recognize opt-out replies and mark contacts Do Not
                  Contact.
                </p>
              </div>
            </div>

            <AutoUnsubscribeSettings />
          </div>

          {/* Opt-Out & Safety */}
          <div className="bg-surface rounded-xl border border-line p-5">
            <div className="flex items-center gap-3 mb-4">
              <div className="size-9 rounded-lg bg-brand/10 flex items-center justify-center">
                <Shield className="size-4 text-brand" />
              </div>
              <div>
                <h3 className="text-sm font-semibold text-fg">
                  Opt-Out & Safety
                </h3>
                <p className="text-xs text-fg-secondary">
                  Global protection settings for all campaigns
                </p>
              </div>
            </div>
            <div className="space-y-1">
              {OPT_OUT_SAFETY_ITEMS.map((item, index) => (
                <div
                  key={item.title}
                  className={`flex items-start justify-between py-3 ${
                    index < OPT_OUT_SAFETY_ITEMS.length - 1
                      ? 'border-b border-line'
                      : ''
                  }`}
                >
                  <div className="flex-1">
                    <div className="flex items-start gap-3">
                      <div className="size-5 rounded-full bg-brand flex items-center justify-center shrink-0 mt-0.5">
                        <Check
                          className="size-3 text-fg-inverse"
                          strokeWidth={3}
                        />
                      </div>
                      <div className="flex-1">
                        <p className="text-sm text-fg">{item.title}</p>
                        <p className="text-xs text-fg-secondary">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </div>
                  <Lock className="size-4 text-fg-secondary ml-3 mt-0.5" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
